import { Skeleton } from "@/components/ui/skeleton";

/**
 * Shell de carregamento da tela de detalhe do freelancer. Renderiza a estrutura
 * (nav + cabeçalho + seções empilhadas) imediatamente enquanto a query por id
 * carrega, em vez de deixar a tela em branco. Espelha o layout real (largura
 * total, em seções) pra não haver salto (CLS) quando os dados chegam.
 */
export function FreelancerDetailsSkeleton() {
  return (
    <div className="space-y-8 fade-in">
      {/* Nav: voltar + ações */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-9 w-24" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-32" />
          <Skeleton className="h-9 w-9" />
        </div>
      </div>

      {/* Cabeçalho do perfil */}
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <Skeleton className="h-8 w-72" />
          <Skeleton className="h-6 w-40 rounded-full" />
        </div>
        <div className="flex flex-wrap gap-4">
          <Skeleton className="h-4 w-48" />
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-40" />
        </div>
        {/* Áreas | Avaliação | Tags */}
        <div className="grid gap-6 border-t pt-5 sm:grid-cols-3">
          {[0, 1, 2].map((col) => (
            <div key={col} className="space-y-2">
              <Skeleton className="h-4 w-28" />
              <div className="flex flex-wrap gap-2">
                <Skeleton className="h-6 w-24 rounded-full" />
                <Skeleton className="h-6 w-20 rounded-full" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Seções empilhadas */}
      {[0, 1, 2].map((section) => (
        <div key={section} className="border-t pt-6 space-y-3">
          <Skeleton className="h-5 w-48" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      ))}
    </div>
  );
}
